import { buildRecipeCardProps } from "../utils/buildRecipeCardProps";
/**
 * Builds the data structure required to render meal sliders for meal programs.
 *
 * @param BuildProgramMealSlidersArgs
 * @returns BuildProgramMealSlidersReturn
 *
 */
export const buildProgramMealSliders = ({ isAnyMealSkippedForDay, moduleConfig, programMealsWithRecipes, recipeHandlerProps_One, recipeImageBaseUrl, setAssignmentId, setIsAddDisabled, setMeals, setQuantity, store, }) => {
    const programMealSliders = programMealsWithRecipes.map((pmwr) => {
        var _a;
        const recipesAvailable = (pmwr === null || pmwr === void 0 ? void 0 : pmwr.recipesForMeal.length) > 0;
        const isDaySkipped = !!(((_a = pmwr.meal) === null || _a === void 0 ? void 0 : _a.IsSkipped) || isAnyMealSkippedForDay);
        const recipeCardsToRender = pmwr === null || pmwr === void 0 ? void 0 : pmwr.recipesForMeal.map((recipe) => {
            const cardProps = buildRecipeCardProps({
                moduleConfig,
                pmwr,
                recipe,
                recipeAutoSelection: moduleConfig.RecipeAutoSelection,
                recipeHandlerProps_One,
                recipeImageBaseUrl,
                setAssignmentId,
                setIsAddDisabled,
                setMeals,
                setQuantity,
                store,
            });
            return Object.assign(Object.assign({}, cardProps), { quantity: isDaySkipped ? 0 : cardProps.quantity });
        });
        return {
            pmwr,
            recipeCardsToRender,
            recipesAvailable,
            isDaySkipped,
        };
    });
    return {
        programMealSliders,
        anyRecipesAvailable: null,
        allRecipesSlider: null,
    };
};
